function calculateDragBoundaries(width, dragDirection) {
  // Simplified: When dragging in a direction, make it easier to drop in that direction
  const bias = dragDirection === 'increasing' ? 0.2 : dragDirection === 'decreasing' ? 0.8 : 0.5;
  return {
    leftBoundary: width * bias,
    rightBoundary: width * bias
  };
}
function determineTargetIndex(relativeX, width, leftBoundary, rightBoundary, hoveredIndex, currentToIndex) {
  if (relativeX < leftBoundary) {
    // Insert before the hovered item
    return hoveredIndex;
  } else if (relativeX > rightBoundary) {
    // Insert after the hovered item
    return hoveredIndex + 1;
  } else {
    // In dead zone - maintain current position if possible
    if (currentToIndex != null) {
      return currentToIndex;
    } else {
      // Fallback to simple midpoint check
      return relativeX < width * 0.5 ? hoveredIndex : hoveredIndex + 1;
    }
  }
}
export function calculatePlaceholderPosition({
  currentToIndex,
  dragDirection,
  hoveredIndex,
  hoveredElement,
  mouseX
}) {
  const rect = hoveredElement.getBoundingClientRect();
  const relativeX = mouseX - rect.left;
  const width = rect.width;
  const {
    leftBoundary,
    rightBoundary
  } = calculateDragBoundaries(width, dragDirection);
  const targetIndex = determineTargetIndex(relativeX, width, leftBoundary, rightBoundary, hoveredIndex, currentToIndex);
  return targetIndex;
}